import { ListItemDropdownKey } from '../tools/Dropdowns/ListItemDropdown';

const ListItemMixin = {
  getInitialState() {
    return {
      thumbnailHovered: false,
      mousedover: false,
      listItemHovered: false,
    };
  },
  onSettingsMenuClicked(event) {
    const rect = event.target.getBoundingClientRect();
    this.props.openDropdown({
      menuType: ListItemDropdownKey,
      config: {
        position: rect,
        childProps: {
          content: this.props.content,
        },
      },
    });
  },
  onMouseEnterThumbnail() {
    this.setState({
      thumbnailHovered: true,
    });
  },
  onMouseLeaveThumbnail() {
    this.setState({
      thumbnailHovered: false,
    });
  },
  onMouseEnterListItem() {
    this.setState({
      mousedover: true,
      listItemHovered: true,
    });
  },
  onMouseLeaveListItem() {
    this.setState({
      mousedover: false,
    });
    if (this.onMouseLeavePreventDefault && this.onMouseLeavePreventDefault()) {
      return;
    }
    this.setState({
      listItemHovered: false,
    });
  },
};

export default ListItemMixin;
